import {add} from '@elements/scroll-animations';
import {onFind} from "@elements/init-modules-in-scope";
import {getPrefixedDataSet} from '@elements/data-set-utils';

export function init() {
    onFind('.js-icon-scroll-animation__icon', function (baseElement) {
        let scrollElements = [];
        scrollElements.push(baseElement);

        add(
            scrollElements,
            calculateAnimationProgress,
            setAnimationProgress
        );
    });
}

// gets element -> returns number between 0 and 1
function calculateAnimationProgress(element) {
    const start = window.innerHeight / 10 ;
    const end = window.innerHeight / 1.5;

    return 1 - Math.max(
            Math.min(
                (element.getBoundingClientRect().top - end) / (start - end),
                1
            ),
            0
        )
}

// gets element & progress (number between 0 - 1) -> sets style of element
function setAnimationProgress(element, progress) {

    let dataAnimation = getPrefixedDataSet('animation', element);
    let parallaxValue = dataAnimation.value;
    let scaleValue = dataAnimation.sacleValue;
    let rotateValue = dataAnimation.rotateValue;
    let translateXValue = dataAnimation.translatexValue;

    let progressTranslateY = progress * parallaxValue;
    let progressTranslateX = translateXValue ? progress * translateXValue : 0;
    let progressScale = scaleValue ? 1 - progress * scaleValue/10 : 1;
    let progressRotate = rotateValue ? progress * rotateValue : 0;

    element.style.transform = "translateY(" + progressTranslateY + "px) translateX(" + progressTranslateX + "px) rotate("  + progressRotate + "deg)  scale("  + progressScale + ")";

}
